var render = function render(){var _vm=this,_c=_vm._self._c;return _c('owal-button',{attrs:{"identifier":_vm.identifier,"corners":_vm.corners},on:{"click":_vm.cycle}},[_c('div',[_vm._v(" "+_vm._s(this.activeState.title)+" "),(this.icon)?_c('font-awesome-icon',{key:"accessory",attrs:{"slot":"accessory","icon":this.icon},slot:"accessory"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }